import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useContext } from 'react';
import PropTypes from 'prop-types';
import { OVContext } from '../../../utils/OVContext';
import Blocks from './Blocks';
import css from './GiftGuide.module.scss';
import CustomCursor from './CustomCursor';
import GiftCards from './GiftCards';
import GiftsFor from './GiftsFor';
import GiftsForMobile from './GiftsForMobile';
import GiftsMisc from './GiftsMisc';
import Hero from './Hero';
import Questions from './Questions';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var GiftGuide = function GiftGuide(_ref) {
  var blocks = _ref.blocks,
      giftCards = _ref.giftCards,
      giftsForHer = _ref.giftsForHer,
      giftsForHim = _ref.giftsForHim,
      giftsMisc = _ref.giftsMisc,
      hero = _ref.hero,
      questions = _ref.questions;

  var _useContext = useContext(OVContext),
      tabletSmall = _useContext.tabletSmall;

  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsx(CustomCursor, {}), /*#__PURE__*/_jsx(Hero, _objectSpread(_objectSpread({}, hero), {}, {
      image: tabletSmall ? hero.imageMobile : hero.image
    })), /*#__PURE__*/_jsx(GiftCards, _objectSpread({}, giftCards)), /*#__PURE__*/_jsx(GiftsMisc, _objectSpread({}, giftsMisc)), !tabletSmall && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(GiftsFor, _objectSpread({}, giftsForHer)), /*#__PURE__*/_jsx(GiftsFor, _objectSpread(_objectSpread({}, giftsForHim), {}, {
        flipped: true
      }))]
    }), tabletSmall && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(GiftsForMobile, _objectSpread({}, giftsForHer)), /*#__PURE__*/_jsx(GiftsForMobile, _objectSpread(_objectSpread({}, giftsForHim), {}, {
        padded: true
      }))]
    }), /*#__PURE__*/_jsx(Blocks, {
      blocks: blocks
    }), /*#__PURE__*/_jsx(Questions, _objectSpread(_objectSpread({}, questions), {}, {
      image: tabletSmall ? questions.imageMobile : questions.image
    }))]
  });
};

GiftGuide.propTypes = {
  blocks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  giftCards: PropTypes.shape(_objectSpread({}, GiftCards.propTypes)).isRequired,
  giftsForHer: PropTypes.shape({}),
  giftsForHim: PropTypes.shape({}),
  questions: PropTypes.shape({
    imageMobile: PropTypes.shape({}),
    image: PropTypes.shape({})
  }),
  giftsMisc: PropTypes.shape(_objectSpread({}, GiftsMisc.propTypes)).isRequired,
  hero: PropTypes.shape(_objectSpread(_objectSpread({}, Hero.propTypes), {}, {
    imageMobile: PropTypes.shape({}),
    image: PropTypes.shape({})
  })).isRequired
};
export default GiftGuide;